import React from 'react';
import { GatsbyBrowser, navigate } from 'gatsby';
import I18nContext from './src/context/I18n';
import ToastProvider from './src/context/Toast';
import WishlistProvider from './src/context/Wishlist';
import Authentication from './src/context/Authentication';
import { getLanguageComponent, isKnownLanguage } from './src/utils/i18n';

const handleActivate = (locale: string) => {
  if (typeof window !== 'undefined') {
    const { pathname } = window.location;
    const currentLanguage = pathname.split('/')?.[1];
    if (isKnownLanguage(currentLanguage) || pathname === '/') {
      navigate(`/${getLanguageComponent(locale)}`);
    } else {
      window.scrollTo(0, 0);
    }
  }
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <I18nContext locale={props?.pageContext?.locale} onActivate={handleActivate}>
      <ToastProvider>
        <WishlistProvider>
          <Authentication>{element}</Authentication>
        </WishlistProvider>
      </ToastProvider>
    </I18nContext>
  );
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location);

  setTimeout(() => {
    window.scrollTo(...(currentPosition || [0, 0]));
  }, 0);

  return false;
};
